var React = require('react');

function Volume (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 19C16.3228 19 19 16.3629 19 12C19 7.63712 16.3228 5 14 5V3C17.866 3 21 7.02944 21 12C21 16.9706 17.866 21 14 21V19Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3L6 8H3.6C2.71634 8 2 8.71634 2 9.6V14.4C2 15.2837 2.71634 16 3.6 16H6L12 21V3Z","fill":"black","key":1}),React.createElement("path",{"d":"M14 17C15.6569 17 17 14.7614 17 12C17 9.23858 15.6569 7 14 7V17Z","fill":"black","key":2})]);
}

Volume.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Volume;

Volume.default = Volume;
